import React from "react";
import { useNavigate } from "react-router-dom";
import "../../css/document-sunpplimentary/Main.css"; // Assuming you have a CSS file for styling

const headers = [
  "Select", // checkbox
  "File",
  "File Name",
  "Size",
  "Comments",
  "Attached By",
  "Date",
];

const sampleData = [
  {
    file: "",
    fileName:
      "BESS PLANT-PSS-FACTORY ACCEPTANCE TEST (FAT) REPORT SUBMISSION OF EMERGENCY DIESEL GENERATOR (500KVA), M/S. ALKHORAYEF COMMERCIAL CO., PM210012-LTG511-INC-BESS- 00033. (LOT-01) REV00-GENERATION PACKAGE (BESS PSS)",
    size: "03",
    comments: "",
    attachedBy: "",
    date: "22/06/2025",
  },
];

const handleReviewOutcomeChange = (index, value) => {
  const updated = [...sampleData];
  updated[index].reviewOutcome = value;
  // setSampleData(updated);
};

const handleCommentsChange = (index, value) => {
  const updated = [...sampleData];
  updated[index].comments = value;
  // setSampleData(updated);
};

const Main = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate("/workflows");
  };

  const handleReviewClick = () => {
    navigate("/document-review");
  };

  return (
    <div className="">
      <div className="topbar">
        <div
          className="header-icon"
          onClick={handleBackClick}
          style={{ cursor: "pointer" }}
        >
          <div className="icon-back">
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M 12.6668 8.7749 H 3.3335 M 3.3335 8.7749 L 8.00016 13.4416 M 3.3335 8.7749 L 8.00016 4.10823" />
              </svg>
            </div>
            <div className="icon-text">Back</div>
          </div>
        </div>
        <div className="document-sunpplimentary">
          <div className="header">
            Document Review (List Mode) - WF-060981: Review
          </div>
          <div className="submit">Submit Selected Documents</div>
        </div>
      </div>
      <div className="sunpplimentary-container">
        <div className="header-row">
          <div className="sub-header">
            <div className="tab" onClick={handleReviewClick}
              style={{ cursor: "pointer" }}>Documents for Review (1)</div>
            <div className="files">Sunpplimentary Files (1)</div>
          </div>
          <div className="text">
            WF-060981 : 1 document in total - 1 with you
          </div>
        </div>
        <div className="section-container">
          <div className="box">
            <div className="box-section">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path
                  d="M 12.6523 22 C 18.1752 22 22.6523 17.5228 22.6523 12 C 22.6523 6.47715 18.1752 2 12.6523 2 C 7.1295 2 2.65234 6.47715 2.65234 12 C 2.65234 17.5228 7.1295 22 12.6523 22 Z"
                  fill="#04395f"
                />
                <path d="M 12.6523 16 V 12 M 12.6523 8 H 12.6623" />
              </svg>
              <div className="info">Information</div>
            </div>
            <div className="workflow">Workflow Note</div>
          </div>
          <div className="section">
            <div>Please see the attached CRS in supplementary Files</div>
            <div>Document Review Status:</div>
            <div className="row1">
              <div>Rejected</div>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="8"
                  viewBox="0 0 32 8"
                  fill="none"
                >
                  <path
                    d="M 31.1993 4.35355 C 31.3945 4.15829 31.3945 3.84171 31.1993 3.64645 L 28.0173 0.464466 C 27.822 0.269204 27.5054 0.269204 27.3102 0.464466 C 27.1149 0.659728 27.1149 0.976311 27.3102 1.17157 L 30.1386 4 L 27.3102 6.82843 C 27.1149 7.02369 27.1149 7.34027 27.3102 7.53553 C 27.5054 7.7308 27.822 7.7308 28.0173 7.53553 L 31.1993 4.35355 Z M 0.652344 4 V 4.5 H 30.8457 V 4 V 3.5 H 0.652344 V 4 Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div>Code 1 (Rejected)</div>
            </div>
            <div className="row1">
              <div>Reviewed with Comments</div>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="8"
                  viewBox="0 0 32 8"
                  fill="none"
                >
                  <path
                    d="M 31.1993 4.35355 C 31.3945 4.15829 31.3945 3.84171 31.1993 3.64645 L 28.0173 0.464466 C 27.822 0.269204 27.5054 0.269204 27.3102 0.464466 C 27.1149 0.659728 27.1149 0.976311 27.3102 1.17157 L 30.1386 4 L 27.3102 6.82843 C 27.1149 7.02369 27.1149 7.34027 27.3102 7.53553 C 27.5054 7.7308 27.822 7.7308 28.0173 7.53553 L 31.1993 4.35355 Z M 0.652344 4 V 4.5 H 30.8457 V 4 V 3.5 H 0.652344 V 4 Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div>Code 2 (Resubmit for Review)</div>
            </div>
            <div className="row1">
              <div>No Comments</div>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="8"
                  viewBox="0 0 32 8"
                  fill="none"
                >
                  <path
                    d="M 31.1993 4.35355 C 31.3945 4.15829 31.3945 3.84171 31.1993 3.64645 L 28.0173 0.464466 C 27.822 0.269204 27.5054 0.269204 27.3102 0.464466 C 27.1149 0.659728 27.1149 0.976311 27.3102 1.17157 L 30.1386 4 L 27.3102 6.82843 C 27.1149 7.02369 27.1149 7.34027 27.3102 7.53553 C 27.5054 7.7308 27.822 7.7308 28.0173 7.53553 L 31.1993 4.35355 Z M 0.652344 4 V 4.5 H 30.8457 V 4 V 3.5 H 0.652344 V 4 Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div>
                Code 4 (No Further Submittal Required Unless Drawing/Document is
                Revised)
              </div>
            </div>
            <div className="row1">
              <div>Accepted For Information</div>
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="8"
                  viewBox="0 0 32 8"
                  fill="none"
                >
                  <path
                    d="M 31.1993 4.35355 C 31.3945 4.15829 31.3945 3.84171 31.1993 3.64645 L 28.0173 0.464466 C 27.822 0.269204 27.5054 0.269204 27.3102 0.464466 C 27.1149 0.659728 27.1149 0.976311 27.3102 1.17157 L 30.1386 4 L 27.3102 6.82843 C 27.1149 7.02369 27.1149 7.34027 27.3102 7.53553 C 27.5054 7.7308 27.822 7.7308 28.0173 7.53553 L 31.1993 4.35355 Z M 0.652344 4 V 4.5 H 30.8457 V 4 V 3.5 H 0.652344 V 4 Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div> Code 5 (for Information)</div>
            </div>
          </div>
        </div>
        <div className="bottom-container">
          <div className="buttons">
            <div className="btn">Zip Download</div>
            <div className="btn">Attach Files</div>
          </div>
          <div className="table-wrapper">
            <div className="scrollable-table">
              <table>
                <thead>
                  <tr>
                    <th>
                      <input type="checkbox" title="Select All" />
                    </th>
                    {headers.slice(1).map((header, idx) => (
                      <th key={idx}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {sampleData.map((row, idx) => (
                    <tr key={idx}>
                      <td>
                        <input type="checkbox" />
                      </td>
                      {/* <td>{row.file}</td> */}
                      <td className="action-cell">
                        <div className="action-icons">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            fill="none"
                            viewBox="0 0 17 16"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            stroke="black"
                            strokeLinejoin="round"
                          >
                            <path d="M 8.65299 8.66675 C 9.02118 8.66675 9.31966 8.36827 9.31966 8.00008 C 9.31966 7.63189 9.02118 7.33341 8.65299 7.33341 C 8.2848 7.33341 7.98633 7.63189 7.98633 8.00008 C 7.98633 8.36827 8.2848 8.66675 8.65299 8.66675 Z" />
                            <path d="M 8.65299 4.00008 C 9.02118 4.00008 9.31966 3.7016 9.31966 3.33341 C 9.31966 2.96522 9.02118 2.66675 8.65299 2.66675 C 8.2848 2.66675 7.98633 2.96522 7.98633 3.33341 C 7.98633 3.7016 8.2848 4.00008 8.65299 4.00008 Z" />
                            <path d="M 8.65299 13.3334 C 9.02118 13.3334 9.31966 13.0349 9.31966 12.6667 C 9.31966 12.2986 9.02118 12.0001 8.65299 12.0001 C 8.2848 12.0001 7.98633 12.2986 7.98633 12.6667 C 7.98633 13.0349 8.2848 13.3334 8.65299 13.3334 Z" />
                          </svg>
                        </div>
                      </td>
                      <td>{row.fileName}</td>
                      <td>{row.size}</td>
                      <td>{row.comments}</td>
                      <td>{row.attachedBy}</td>
                      <td>{row.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* CSS */}
            <style jsx>{`
              .scrollable-table {
                overflow-x: auto;
                border: 1px solid #ccc;
              }

              table {
                width: max-content;
                min-width: 100%;
                border-collapse: collapse;
              }

              th,
              td {
                border: 1px solid #dcdcdc;
                padding: 10px 12px;
                font-size: 14px;
                white-space: nowrap;
              }

              th {
                background-color: #f0f0f0;
                font-weight: bold;
              }

              .action-cell {
                vertical-align: middle;
                height: 90px;
              }

              .action-icons {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 6px;
                justify-content: center;
                height: 100%;
              }

              .action-icons svg {
                cursor: pointer;
              }

              .form-select,
              .form-input {
                width: 100%;
                padding: 7px 14px;
                font-size: 14px;
                border-radius: 5px;
                border: 1px solid #949494;
                background-color: #ffffff;
                box-sizing: border-box;
              }
            `}</style>
          </div>
          <div class="pagination-container">
            <div class="pagination-info">
              <strong>1–13</strong> of 13 Results{" "}
              <span>(0 Selected)</span>
            </div>
            <div class="pagination-controls">
              <button class="page-btn" disabled>
                ‹ Prev
              </button>
              <button class="page-btn active">1</button>
              <button class="page-btn">2</button>
              <button class="page-btn">Next ›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
